<template>
   <el-dialog title="添加校区" v-model="dialogVisible" :modal-append-to-body="false" @close="close">
      <el-form label-position="top" :model="adForm">
         <el-form-item label="校区">
            <div style="display: flex; align-items: center">
               <el-select v-model="adForm.unids" placeholder="请选择校区" filterable multiple style="flex: 1; margin-right: 8px">
                  <el-option v-for="item in campusZoneList" :key="item.value" :label="item.label" :value="item.value" />
               </el-select>
               <el-button type="primary" @click="handleAddCampusZones">添加</el-button>
            </div>
         </el-form-item>
         <el-form-item label="校区">
            <div class="card-wrap">
               <div v-for="item in adForm.list" :key="item.value" class="dialog-item">
                  <span>{{ item.label }}</span>
                  <el-button type="text" icon="circle-close" @click="handleDeleteCampus(item.value)"></el-button>
               </div>
            </div>
            <div class="card-footer">
               共计{{ adForm.list.length }}所学校
            </div>
         </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
         <el-button @click="dialogVisible = false">取 消</el-button>
         <el-button type="primary" @click="onSubimtForm">确 定</el-button>
      </div>
   </el-dialog>
</template>

<script>
export default {
   props: {
      campusZoneList: {
         type: Array,
         default: () => [],
      },
   },
   data() {
      return {
         dialogVisible: false,
         dialogType: '',
         adForm: {
            unids: [],
            list: [],
         },
      };
   },
   methods: {
      // 展示
      show(row) {
         if (row) {
            this.dialogType = row.type;
            this.adForm.list = row.data;
         }
         this.dialogVisible = true;
      },
      // 添加
      handleAddCampusZones() {
         if (!this.adForm.unids || this.adForm.unids.length === 0) {
            return;
         }
         const newItems = [];
         this.adForm.unids.forEach((unid) => {
            // 检查是否已存在
            const exists = this.adForm.list.find((item) => item.value === unid);
            if (!exists) {
               // 从校区列表中查找对应的校区信息
               const campus = this.campusZoneList.find((item) => item.value === unid);
               if (campus) {
                  newItems.push(campus);
               }
            }
         });
         if (newItems.length > 0) {
            this.adForm.list = [...this.adForm.list, ...newItems];
            this.adForm.unids = [];
         }
      },
      // 删除
      handleDeleteCampus(unid) {
         const index = this.adForm.list.map(
            (item) => item.value
         ).indexOf(unid);
         this.adForm.list.splice(index, 1);
      },
      // 提交
      onSubimtForm() {
         let baseUrl = `${this.$util.domain}/adminapi/v2/ad/editOrAddShieldAd`;
         let params = {};
         if (this.dialogType === "barrierFree") { // 无障碍屏蔽
            baseUrl = `${this.$util.domain}/adminapi/v1/barrierFree/editOrAddBarrierFree`;
         } else if (this.dialogType === "homeAd") {
            params.type = "SHIELD_HOME_SCREEN_AD";
         } else if (this.dialogType === "flowAd") {
            params.type = "SHIELD_MINE_INFORMATION_FLOW_AD";
         } else if (this.dialogType === "openAd") {
            params.type = "SHIELD_OPEN_SCREEN_AD";
         } else if (this.dialogType === "runAd") {
            params.type = "SHIELD_RUN_SCREEN_AD";
         } else if (this.dialogType === "homeFlowAd") {
            params.type = "HOME_INFORMATION_AD";
         } else if (this.dialogType === "runFlowAd") {
            params.type = "SHIELD_RUN_END_FEED_AD";
         } else if (this.dialogType === "floatingAd") {
            params.type = "SHIELD_FLOATING_AD";
         } else if (this.dialogType === "beiziConfigs") { // 倍孜配置
            baseUrl = `${this.$util.domain}/adminapi/v2/ad/distribution/edit`;
            params.type = 1;
         } else if (this.dialogType === "meishuConfigs") { // 美数配置
            baseUrl = `${this.$util.domain}/adminapi/v2/ad/distribution/edit`;
            params.type = 2;
         }

         if (this.adForm.list && this.adForm.list.length) { // 无障碍屏蔽
            if (this.dialogType === "barrierFree") {
               params = this.adForm.list.map((item) => item.value);
            } else if (this.dialogType === "beiziConfigs") { // 倍孜配置
               params.models = this.adForm.list.map((item) => ({
                  unid: item.value,
                  type: 1,
                  campusName: item.label
               }))
            } else if (this.dialogType === "meishuConfigs") { // 美数配置
               params.models = this.adForm.list.map((item) => ({
                  unid: item.value,
                  type: 2,
                  campusName: item.label
               }))
            } else {
               params.unid = this.adForm.list.map((item) => item.value).join(",") || "";
            }
         }

         let bodyData = undefined;
         if (this.dialogType === "barrierFree") {
            bodyData = JSON.stringify([...params]);
         } else if (this.dialogType === "beiziConfigs") { // 倍孜配置
            bodyData = params;
         } else if (this.dialogType === "meishuConfigs") { // 美数配置
            bodyData = params;
         } else {
            bodyData = JSON.stringify([{ ...params }]);
         }

         this.$http({
            url: baseUrl,
            method: "POST",
            dataType: "json",
            body: bodyData,
         }).then((res) => {
            if (res.body.error === 10000) {
               this.dialogVisible = false;
               this.$emit("refreshCampusData", this.dialogType);
            } else {
               this.$util.errorMsg(res.body.message);
            }
         }).catch((error) => {
            this.$util.errorMsg("请重试");
            this.dialogVisible = false;
         });
      },
      // 关闭
      close() {
         this.adForm.unids = [];
         this.adForm.list = [];
      },
   },
};
</script>

<style scoped>
.card-wrap {
   box-sizing: border-box;
   width: 100%;
   height: 200px;
   overflow: auto;
   padding: 10px;
   margin: 8px 0 4px;
   border: 1px solid #c0ccda;
   border-radius: 4px;
   font-size: 14px;
   line-height: 1.5;
}

.dialog-item {
   display: inline-block;
   margin: 0 4px 4px;
   padding: 4px;
   border: 1px solid #c0ccda;
   border-radius: 4px;
   font-size: 14px;
   line-height: 1.5;
}

.card-footer {
   text-align: right;
   font-size: 14px;
   line-height: 1.5;
}
</style>


// WEBPACK FOOTER //
// EditCampusDialog.vue?035323d1